module.exports = __webpack_public_path__ + "media/Kitemill om sikker energiforsyning og bærekraft.2ef38308.mp4";